import { render, staticRenderFns } from "./ExtendedDataPicker.vue?vue&type=template&id=4523462e&"
import script from "./ExtendedDataPicker.vue?vue&type=script&lang=ts&"
export * from "./ExtendedDataPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports